import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { SnackbarState, ToastState } from '../../types';

type SnackbarAction = { type: string; payload?: SnackbarState | null };

const initialState: SnackbarState = {
  isVisible: false,
  message: '',
  type: 'info',
  onToastClose: () => {},
};

const snackbarReducer = (
  state: SnackbarState,
  action: SnackbarAction,
): ToastState => {
  switch (action.type) {
    case types.SHOW_SNACKBAR:
      return {
        ...state,
        ...action.payload,
      };
    case types.HIDE_SNACKBAR: {
      return initialState;
    }
    default:
      return initialState;
  }
};

type SnackbarToastContextType = [
  SnackbarState | null,
  Dispatch<SnackbarAction>,
];
export const SnackbarContext = createContext<SnackbarToastContextType>([
  initialState,
  () => initialState,
]);

const SnackbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [snackbarInfo, dispatchSnackbarInfo] = useReducer(
    snackbarReducer,
    initialState,
  );

  return (
    <SnackbarContext.Provider value={[snackbarInfo, dispatchSnackbarInfo]}>
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
